import Cookies from 'js-cookie'
import { REMEMBER_TIME, REMEMBER_T } from '@/utils/constant'
import { checkToken } from '../api/common/public'
import store from '@/store'
import router from '@/router'
const TokenKey = 'token'

export function getToken(name) {
  return Cookies.get(name || TokenKey)
}

export function setToken(token, name) {
  return Cookies.set(name || TokenKey, token)
}

export function removeToken(name) {
  return Cookies.remove(name || TokenKey)
}

export function clearRememberMe() {
  // loginFn.removeUserInfo()
  return Cookies.remove('rememberMe')
}

const loginFn = {
  name: 'userInfo',
  setUserInfo(value, isRemember) {
    let expires = REMEMBER_TIME
    if (value instanceof Object) {
      if (isRemember) {
        value.remember = isRemember
        value._t = new Date().getTime() + REMEMBER_T
      } else {
        if (value._t) {
          if (value._t - new Date().getTime() <= 0) {
            this.removeUserInfo()
          }
        } else {
          expires = ''
        }
      }
    }
    const params = JSON.stringify(value)
    Cookies.set(this.name, params, { expires })
  },
  getUserInfo() {
    const info = Cookies.get(this.name)
    let data = {}
    if (info) {
      data = JSON.parse(info)
      if (data._t - new Date().getTime() <= 0) {
        this.removeUserInfo()
      }
    }
    return data
  },
  removeUserInfo() {
    Cookies.remove(this.name)
  },
  // 检测用户token是否失效并获取最新用户信息
  checkTokenStatus() {
    // const _this = this
    const token = getToken()
    // window.checkTokenError = true
    if (token) {
      setToken(token, 'token')
      // 若检查token有效则正常进行，若检查token已失效，走错误提示
      checkToken()
    } else {
      store.dispatch('user/resetToken')
    }
  },
  // 退出至登录页面
  async toLogin(fullPath) {
    if (window.__POWERED_BY_QIANKUN__) {
      window?.__icasLogout?.()
      window._parent_store_.setGlobalState({
        isLogout: true
      })
      return
    }
    await store.dispatch('user/logout')
    // const loginPage = window.localStorage.getItem('loginPage')
    // if (loginPage === '2') {
    //   router.push(`/old-login?redirect=${fullPath}`)
    // } else {
    router.push(`/login?redirect=${fullPath}`)
    // }
  }
}

export {
  loginFn
}
